import { formatFontDisplayName } from './formatFontDisplayName';
import _ from 'lodash';
const MJ_FONT_FAMILY_MATCHER = '\\sfont-family="([^"]+)"';
const STYLES_MATCHER = '\\sstyle="([^"]+)"';
const FONT_FAMILY_IN_STYLES_MATCHER = 'font-family:([^;]+);?';
export const getMjmlFonts = (mjml, extendedList) => {
  const mjFonts = [...mjml.matchAll(new RegExp(MJ_FONT_FAMILY_MATCHER, 'gm'))].map(match => match[1]);
  const styles = [...mjml.matchAll(new RegExp(STYLES_MATCHER, 'gm'))].map(match => _.unescape(match[1]));
  const fontsFromStyles = styles.map(style => [...style.matchAll(new RegExp(FONT_FAMILY_IN_STYLES_MATCHER, 'gm'))]).flat().flatMap(matches => matches[1].trim());
  const mjmlFonts = [...mjFonts, ...fontsFromStyles].map(formatFontDisplayName);
  const uniqueMjmlFonts = [...new Set(mjmlFonts)];
  const emailFontOptions = uniqueMjmlFonts.map(font => {
    const displayName = formatFontDisplayName(font);
    return {
      displayName,
      cssFontFamily: font.toLocaleLowerCase().replaceAll(', ', ',')
    };
  });
  const predefinedFonts = Object.values(extendedList).filter(font => font.supportedInHtmlEmails && !uniqueMjmlFonts.includes(font.displayName));
  return [...emailFontOptions, ...predefinedFonts].sort((a, b) => a.displayName.localeCompare(b.displayName));
};
//# sourceMappingURL=getMjmlFonts.js.map